// extracted by mini-css-extract-plugin
module.exports = {"reviews__header":"Reviews_reviews__header__2IApt","reviews__cards":"Reviews_reviews__cards__M6j4i","reviews__single-review":"Reviews_reviews__single-review__2jZRs"};